import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SinglePostTemplate from "./sections/SinglePostTemplate"
import GlamVaultUniversalFooter from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <SinglePostTemplate />
      <GlamVaultUniversalFooter />
    </div>
  )
}
